import axios from '../../../service/index'
import React, { Component } from 'react'
import {Button, message, Spin} from 'antd'
import './saveimg.less'
import punleft from '../../../assets/images/pun-left.png'
import punrigt from '../../../assets/images/pun-rig.png'
// let corpid = 'ww05f5d2c3824d6d4e'
// let windowurl = "http://test-videocadmin.codingke.com/savimg"
class SaveImg extends Component {
  state = {
    userId: '',
    postersId: '',
    posterObj: {},
    loading: false
  }
  componentDidMount() {
    let {id, userId} = this.props.location.state
    this.setState({userId, postersId: id},() => {
      this.InitHandle()
    })

    // let formdata = new FormData()
    // formdata.append('url', windowurl)
    // axios.post('config', formdata).then(res => {
    //   let dataObj = res.data.data
    //   window.wx.config({
    //     timestamp: dataObj.timestamp, // 必填，生成签名的时间戳
    //     nonceStr: dataObj.noncestr,
    //     beta: true,
    //     debug: true,
    //     appId: corpid,
    //     signature: dataObj.signature,
    //     jsApiList: ['showOptionMenu', 'showMenuItems', 'onMenuShareTimeline']
    //   })
    //   window.wx.ready(function() {
    //     alert('cg')
    //     window.wx.showOptionMenu()
    //     window.wx.showMenuItems({
    //       menuList: ["menuItem:share:appMessage", "menuItem:favorite","menuItem:copyUrl"], // 要显示的菜单项
    //       success: function (res) {
    //         // alert(res+'已显示“阅读模式”，“分享到朋友圈”，“复制链接”等按钮')
    //       },
    //       fail: function (res) {
    //         alert(JSON.stringify(res));
    //       }
    //     });
    //   })
    // })
  }
  configSave() {
    
  }
  InitHandle() {
    let {userId, postersId} = this.state
    // let userid = 'wm6LPiDAAA5vmb08owQQ4DJcvUVdd3xA'
    this.setState({loading: true},() => {
      // axios.get(`activityxet/generate/${1}/${userid}`).then(res => {
      axios.get(`activityxet/generate/${postersId}/${userId}`).then(res => {
        this.setState({loading: false})
        if(res.data.code === '200'){
          this.setState({posterObj: res.data.data})
        }
      })
    })    
  }
  copyPosters = () => {
    if(!this.state.posterObj.des) return message.error('未上传文案')
      let oInput = document.createElement("input");
      oInput.value = this.state.posterObj.des;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      message.success('文案已复制');
      oInput.remove();
  }
  downLinkImg = () => {
    // alert(1)
    var image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
          alert('load')
          var canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          var context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          var url = canvas.toDataURL('image/jpg')
          var a = document.createElement('a')
          var event = new MouseEvent('click')
          a.download ='phone'
          a.href = url
          a.dispatchEvent(event)
      }
      image.src = this.state.posterObj.activityBill;
      // image.src = 'https://kodo.1000phone.com/FiMN0eHxyWzHxdXQ5oS1R1r7a6qL'
  }
  render() {
    return (
      <div className="saveImg">
        <Spin spinning={this.state.loading}>
          <img src={this.state.posterObj.activityBill} className="posters" alt="" />
          <div className="pos-text">
            <img src={punleft} className="pun-left" alt="" />
            {this.state.posterObj.des}
            <img src={punrigt} className="pun-rigt" alt="" />
          </div>
          <div className="red-color">长按保存海报～</div>
          <div className="bot-btn">
            <Button type="primary" onClick={this.copyPosters}>复制文案</Button>
            {/* <Button onClick={this.downLinkImg}>复制文案</Button> */}
          </div>
        </Spin>
      </div>
    )
  }
}
export default SaveImg